import store from '@/store'

export const logout = () => {
  store.commit('setIsLoading', false)
  Promise.resolve(localStorage.clear()).then(() => (location.href = '/login'))
}

export const logoutAndRefresh = () => {
  store.commit('setIsLoading', false)
  Promise.resolve(localStorage.clear()).then(() => (location.reload()))
}
